var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoilerGas = function SvgBoilerGas(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.202,
    d: "M10.419 1.106h11.123c2.29 0 4.156 1.878 4.156 4.166v19.7c0 2.288-1.866 4.166-4.156 4.166H10.42c-2.29 0-4.169-1.878-4.169-4.166v-19.7c0-2.288 1.88-4.166 4.169-4.166z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.389,
    d: "M12.833 29.598v1.207"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.354,
    d: "M19.452 29.402v1.426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.389,
    d: "M6.81 21.34h18.142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.389,
    d: "M16.23 26.116a.834.834 0 1 0 0-1.666.844.844 0 0 0-.847.833c0 .46.386.833.846.833z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.389,
    d: "M18.245 17.112c.485-.36 1.842-1.94 2.04-3.171.386-2.152-2.861-4.44-3.01-7.612-.038-.161-.063-.41-.274-.41-.187 0-.274.137-.41.274-1.544 1.579-2.925 2.736-4.02 4.713a6.2 6.2 0 0 0-.66 1.84l-.074.548c-.174 1.355.734 2.947 1.767 3.818"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoilerGas);
export default ForwardRef;